<template>
  <h2 class="text-neutral-5 m-0 text-base font-normal leading-6 sm:text-lg sm:font-medium">
    <slot></slot>
  </h2>
</template>
